/* tutor-1 (D, #665): LAPIDA DE LAS DOS CASAS. Hasta esta tanda cada constante de abajo se bifurcaba por
   IS_APP_BUILD: la web pintaba la barra pegada de 56 y la app la pildora. Desde la barra unica la web del
   telefono (y la tablet, firma 8) toma la pildora de la app, asi que las dos casas COINCIDEN y las constantes
   quedan SIN bifurcar, con el valor que tenia la app. Lo que la tablet y la computadora necesitan aparte
   (la pildora a 16 del borde en la tablet; sin pildora desde 1024) va en variantes de ancho dentro de la MISMA
   cadena. Lo que sigue escrito abajo sobre "web: 56" es historia. */

/* LA FUENTE ÚNICA DE VERDAD DEL BOTTOM NAV. Leer entero antes de tocar un número.

   EL PROBLEMA QUE ESTE MÓDULO EXISTE PARA MATAR. Hasta la T2 el alto del nav
   estaba escrito a mano en NUEVE lugares: el `bottom` de SessionActionBar, el
   `pb` del área de contenido en App.js, y el `pb` de los modales de AutoSplit
   (x2), CreditPack, OfflinePro, Flashcards (x2) y PendingPage. Todos decían
   "56px" o "3.5rem" por su cuenta. Cambiar el alto del nav significaba
   encontrar los nueve y acertarle a los nueve; olvidarse de uno deja un modal
   tapado o una barra encimada, y nada lo detecta hasta el smoke en el teléfono.

   Ahora el número vive AQUÍ y nada más aquí. Hay un test que escanea src/ y
   falla si alguien vuelve a escribir el alto a mano en otro archivo.

   POR QUÉ SON CADENAS LITERALES Y NO NÚMEROS INTERPOLADOS. Tailwind construye
   el CSS escaneando el TEXTO del código fuente: sólo genera una utilidad si ve
   su nombre completo escrito literal. Una clase de padding armada por
   interpolación —metiendo la constante numérica dentro del calc con template
   string— no se genera nunca, y el padding simplemente no existe en
   producción. Por eso cada constante de abajo es la cadena entera, escrita dos
   veces (app y web), y el número suelto (BOTTOM_NAV_FOOTPRINT_PX) existe para
   que los tests puedan comprobar que las cadenas y el número no se separaron.

   (Y ojo con los ejemplos: este comentario TENÍA escrito el caso malo con su
   sintaxis de clase completa, y el escáner de Tailwind lo tomó por una clase
   de verdad. Generó un calc con la interpolación sin resolver y el minificador
   de CSS tumbó el build entero. Aquí no se escriben nombres de clase de
   ejemplo, ni siquiera dentro de un comentario.)

   POR QUÉ DOS VALORES Y NO UNO. El contrato de la web NO cambia en esta tanda:
   sigue siendo la barra pegada de 56px con las mismas cadenas de siempre,
   carácter por carácter. La app estrena píldora. Un solo valor obligaría a
   mover la web, que es justo lo prohibido. El corte es por build (IS_APP_BUILD,
   runtime — ver lib/buildTarget.js), igual que el resto de la T2. */

/** Alto TOTAL que el nav ocupa por encima del safe area inferior.
 *
 *  web : 56 = la barra pegada de siempre (h-14).
 *  app : 70 = fila de 62px + 8px de aire bajo la píldora.
 *
 *  De dónde salió el 58 (post-smoke de Carlos: la píldora se veía chica). El
 *  contenido de cada destino subió un paso — ícono 20→24px, label 10→11px,
 *  separación 2→4px — o sea 41px de pila. 58 dejaba ~8.5px de aire arriba y
 *  abajo, que es el MISMO ritmo de 8px con que la píldora se despega del borde
 *  inferior, así que la cápsula se leía pareja por los cuatro lados.
 *
 *  POR QUÉ SUBIÓ A 62 (COS-29b, smoke-2 de Carlos: "el número del badge quedó
 *  en el mero borde"). La cuenta, en el aparato: la pila de contenido mide
 *  ~44.5px (ícono 24 + separación 4 + renglón del label ~16.5) y va CENTRADA,
 *  así que con una fila de 58 el ícono empieza a ~6.75px del borde de arriba. El
 *  badge de "More" cuelga de la esquina del ícono con 6px de sobresalida
 *  (`-top-1.5`), o sea que su borde superior caía a ~0.75px del filo de la
 *  cápsula — y como la cápsula es redonda, a la altura del badge el vidrio ya
 *  va curvándose hacia abajo: el número quedaba montado sobre el borde.
 *
 *  El arreglo va por las DOS mitades, porque cada una sola pediría el doble:
 *  la fila sube 4px (el ícono baja 2) y la sobresalida del badge baja a 4px
 *  (`-top-1`, en MobileBottomNav.js). Entre las dos, el borde de arriba del
 *  badge pasa de ~0.75px a ~4.75px del filo. Subir SÓLO la fila pediría 66px
 *  (huella 74) para el mismo aire, y eso ya se come un renglón de contenido en
 *  pantallas chicas; bajar SÓLO el ancla metería el número encima del
 *  hamburguesa. 62 mantiene el look: el aire de la cápsula pasa de ~8.5 a
 *  ~10.5px arriba y abajo, sigue leyéndose pareja, y el ritmo de 8px con que se
 *  despega del borde inferior no se mueve. */
export const BOTTOM_NAV_FOOTPRINT_PX = 70;

/** Alto de la fila de destinos (la huella menos el aire de la píldora). */
export const NAV_ROW_HEIGHT_CLASS = 'h-[62px]';

/** Aire entre la píldora y el borde inferior, POR ENCIMA del safe area.
 *  El fallback 0px no es opcional: sin él, en un aparato sin safe area el
 *  calc() entero se invalida y la píldora se pega al borde. */
export const PILL_BOTTOM_CLASS = 'bottom-[calc(env(safe-area-inset-bottom,0px)+8px)]';

/** tutor-1 (D, firma 8): en la tablet (768 a 1023) la pildora va a 16 del borde de abajo, mas la zona segura. */
export const PILL_BOTTOM_TABLET_CLASS = 'md:bottom-[calc(env(safe-area-inset-bottom,0px)+16px)]';

/** Dónde se apoya una barra de acción fija: EXACTAMENTE sobre la huella del
 *  nav. Ni un píxel encimada, ni un píxel de hueco. */
export const ACTION_BAR_BOTTOM_CLASS = 'bottom-[calc(70px+env(safe-area-inset-bottom,0px))]';

/** remates-2 (E) -- EL ALTO DEL AREA DE CONTENIDO DEL CHASIS (el `<main>` de App.js).
 *
 *  dashboard-rediseno (4.1): se mudo a `lib/medidasDelChasis.js`, porque lleva el
 *  alto de la barra de arriba, que desde esta tanda vive alla. Se re-exporta aqui
 *  para que nadie que ya lo importaba de este modulo se desconecte. */
export { CONTENT_HEIGHT_CLASS } from './medidasDelChasis';

/** Colchón del área de contenido scrolleable del chasis (App.js).
 *  En app lleva 28px de aire extra en vez de 16: la píldora es TRANSLÚCIDA y lo
 *  que quede debajo se alcanza a ver borroso, o sea parece contenido cortado.
 *  remates-2 (E): en WEB ya no compensa la barra, porque el area de contenido
 *  termina arriba de ella (ver el alto, arriba); se queda el aire de 16 px de
 *  siempre, el mismo del acolchado de arriba. */
export const CONTENT_CLEARANCE_CLASS = 'pb-[calc(70px+env(safe-area-inset-bottom)+28px)]';

/** Colchón de un overlay a pantalla completa (modales), para que su tarjeta
 *  centrada no quede debajo del nav en mobile. */
export const MODAL_CLEARANCE_CLASS = 'pb-[calc(70px+env(safe-area-inset-bottom)+16px)]';

/** Colchón de un panel que scrollea POR SU CUENTA dentro de la pantalla (las
 *  dos listas de documentos del Panel).
 *
 *  Por qué necesita el suyo: el colchón del chasis vive en el `pb` del <main>,
 *  y un contenedor con `overflow-y-auto` propio NO lo hereda — su región
 *  scrolleable termina donde termina SU padding. Con `pb-16` a pelo (64px, de
 *  antes de que existiera la píldora) el último documento no llegaba a subir
 *  entero por encima del vidrio y su botón de eliminar quedaba a medias
 *  (reporte de Carlos en el smoke). Aquí el colchón se ata a la huella real
 *  más 24px de aire, así que el último renglón termina SIEMPRE arriba de la
 *  píldora con sus 44pt de toque libres. Web: `pb-16`, idéntico a hoy. */
export const INNER_SCROLL_CLEARANCE_CLASS = 'pb-[calc(70px+env(safe-area-inset-bottom,0px)+24px)] lg:pb-16';

/** La OTRA mitad del trato de arriba: que el panel llegue hasta el FONDO de la
 *  pantalla, no hasta donde termina el colchón del chasis.
 *
 *  EL CORTE QUE ESTO DESHACE (segundo smoke de Carlos). El área de contenido
 *  del chasis reserva su colchón con `padding-bottom`, y una pantalla que se
 *  declara `h-full` resuelve ese 100% contra la caja de CONTENIDO — que ya
 *  excluye el padding. Resultado: el panel terminaba 98px+safe por encima del
 *  borde inferior, o sea muy por encima de la píldora, y las tarjetas nunca
 *  llegaban a pasar por debajo del vidrio. El vidrio no tenía qué desenfocar:
 *  se veía flotando sobre un hueco muerto.
 *
 *  Lo que hace: le devuelve al panel exactamente el colchón que el chasis se
 *  reservó (los mismos 98px+safe de CONTENT_CLEARANCE_CLASS), para que su
 *  región scrolleable llegue al borde de la pantalla y el contenido se deslice
 *  DETRÁS de la píldora. El margen negativo de la misma medida es obligatorio:
 *  sin él el panel sobresale de la caja del scroller de afuera y el chasis
 *  entero se vuelve scrolleable — el encabezado y los controles fijos se irían
 *  hacia arriba con el dedo. Con él, la caja de margen mide lo de siempre y
 *  sólo la caja de borde se derrama sobre el padding, que es donde se quiere.
 *
 *  El colchón INTERIOR de cada lista (INNER_SCROLL_CLEARANCE_CLASS) es el que
 *  sigue garantizando que, al llegar al fondo, el último documento y su botón
 *  de eliminar queden completos POR ENCIMA del vidrio. Los dos se necesitan:
 *  éste da el recorrido, aquél da el remate.
 *
 *  md: vuelve a `h-full` — en desktop no hay píldora que atravesar y el chasis
 *  usa otro colchón (md:pb-8). Web: `h-full`, exactamente como hoy. */
export const PANE_FULL_BLEED_HEIGHT_CLASS = 'h-[calc(100%+98px+env(safe-area-inset-bottom))] mb-[calc(-98px_-_env(safe-area-inset-bottom))] lg:h-full lg:mb-0';
